import PropTypes from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { iso8601DurationPropType } from '../common/iso-8601-duration-prop-type'

/**
 * @typedef {Object} ReducedWeeklyRestPeriodCompensationRest
 * @property {ISO8601} [dueDate]  - The date till then the compensation has to be taken
 * @property {ISO8601Duration} [duration] - The duration of the compensation
 */
export const reducedWeeklyRestPeriodCompensationRestPropType = PropTypes.shape({
    dueDate: iso8601PropType,
    duration: iso8601DurationPropType
})
